import { render } from "./ComparisonModal.vue?vue&type=template&id=050e768a&scoped=true"
import script from "./ComparisonModal.vue?vue&type=script&lang=js"
export * from "./ComparisonModal.vue?vue&type=script&lang=js"

import "./ComparisonModal.vue?vue&type=style&index=0&id=050e768a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050e768a"]])

export default __exports__